export class MessageModel {
    constructor(message?: string, style?: string) {
      this.message = message;
      this.style = style;
    }
  
    message?: string;
    style?: string;
  }
  